// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21V3H1V21L23 21ZM10.0703 12L6.33118 15.7442L4.91602 14.3309L7.24382 12L4.91602 9.669L6.33118 8.25574L10.0703 12ZM19.0002 17H12.0002V15H19.0002V17Z"}}]};

const TerminalRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal-rectangle-filled',
    ref,
    icon: element,
  },
));

TerminalRectangleFilledIcon.displayName = 'TerminalRectangleFilledIcon';

export default TerminalRectangleFilledIcon;
